import React from 'react'

import Base from '../_Base'

const RatingsUpActive = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M11,0 C13.206,0 15,1.794 15,4 L15,7 L19.382,7 C20.146,7 20.831,7.424 21.171,8.106 L22.224,10.211 C22.784,11.331 22.784,12.669 22.224,13.789 L21,16.236 L21,20 C21,21.103 20.103,22 19,22 L6,22 C5.447,22 5,21.553 5,21 L5,11 C5,10.725 5.113,10.461 5.314,10.272 L7.423,8.283 C7.795,7.906 8,7.408 8,6.879 L8,1 C8,0.447 8.447,0 9,0 L11,0 Z M2,9.9995 C2.552,9.9995 3,10.4475 3,10.9995 L3,20.9375 C3,21.451 2.61371429,21.873102 2.11656851,21.9307824 L2,21.9375 C1.448,21.9375 1,21.4905 1,20.9375 L1,10.9995 C1,10.4475 1.448,9.9995 2,9.9995 Z"
      fillRule="evenodd"
    />
  </Base>
)

export default RatingsUpActive
